"use client";

import * as React from "react";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import { tokensToCssVars, defaultTokens } from "@kiwicom/orbit-design-tokens";
import { parseToRgba } from "color2k";
import QueryContextProvider from "./QueryContext/Provider";
import RandomIdProvider from "./RandomId/Provider";
// we need only palette tokens for whitelables
const getCssVarsForWL = theme => Object.keys(theme).reduce((acc, key) => {
  if (key.startsWith("palette")) {
    try {
      acc[key] = parseToRgba(theme[key]).slice(0, -1).join(", ");
    } catch (e) {
      console.error("OrbitProvider-getCssVarsForWL: couldn't parse palette color, using fallback value from defaultTheme", key, e);
      acc[key] = parseToRgba(defaultTokens[key]).slice(0, -1).join(", ");
    }
  }
  return acc;
}, {});

/**
 *
 * Use OrbitProvider with useId prop as follows to still use `react-uid`:
 * ```jsx
    <UIDReset>
      <UIDFork>
        <OrbitProvider theme={theme} useId={useUID}>
          {children}
        </OrbitProvider>
      </UIDFork>
    </UIDReset>
 * ```
 *
 */

const OrbitProvider = ({
  theme,
  children,
  useId
}) => {
  return /*#__PURE__*/React.createElement(RandomIdProvider, {
    useId: useId
  }, /*#__PURE__*/React.createElement("style", {
    id: "orbit-theme-css-vars"
  }, tokensToCssVars({
    tokens: getCssVarsForWL(theme.orbit),
    cssClass: ":root"
  })), /*#__PURE__*/React.createElement(StyledThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(QueryContextProvider, null, children)));
};
export default OrbitProvider;